import { bodyBgGradientCode } from './BodyBgStore';

export const updateBodyBgGradientCode = (value) => bodyBgGradientCode.update(oldValue => value);
